import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import format from 'date-fns/format';
import { injectIntl } from 'react-intl';

import LocalisedMessage from 'components/Common/LocalisedMessage';

import ModalWrapper from 'components/Modals/ModalWrapper';

import { hideFormSigning, revertForm, signForm, signFormGroup, revertFormGroup } from 'actions/form';

class FormSigning extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    formType: PropTypes.string,
    id: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func,
    formData: PropTypes.shape({}),
    questionnaire: PropTypes.shape({
      name: PropTypes.shape({
        name: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string
      }),
      signer: PropTypes.shape({
        name: PropTypes.string,
        capacity: PropTypes.string
      })
    }),
    isSigningForm: PropTypes.bool,
    isNameInvalid: PropTypes.bool,
    usePreQualifyingQuestionnaire: PropTypes.bool,
    formGroup: PropTypes.shape({
      key: PropTypes.string,
      formTypes: PropTypes.arrayOf(PropTypes.string)
    }),
    formGroupId: PropTypes.string,
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
      messages: PropTypes.shape()
    }).isRequired,
    selectedAccountId: PropTypes.number,
    customerId: PropTypes.string,
    showAffidavit: PropTypes.bool,
    history: PropTypes.shape({
      listen: PropTypes.func.isRequired
    }).isRequired,
  };

  static defaultProps = {
    formType: '',
    id: null,
    formData: null,
    questionnaire: null,
    onSubmit: null,
    isSigningForm: false,
    isNameInvalid: false,
    usePreQualifyingQuestionnaire: false,
    formGroup: null,
    formGroupId: null,
    selectedAccountId: null,
    customerId: null,
    showAffidavit: false
  };

  constructor(props) {
    super(props);

    this.state = {
      printName: '',
      signDate: '',
      signName: '',
      capacity: ''
    };
  }

  componentDidMount() {
    this.setStateParameters();

    const { history } = this.props;

    // Listen for browser navigation (back/forward)
    this.navigationListener = history.listen((location, action) => {
      if (action === 'POP') {
        this.onCancel();
      }
    });
  }

  componentWillUnmount() {
    if (this.navigationListener) {
      this.navigationListener();
    }
  }

  onChangePrintName(event) { this.setState({ signName: event.target.value }); }

  onChangeCapacity(event) { this.setState({ capacity: event.target.value }); }

  onCancel() {
    const { dispatch, id, onCancel, formGroupId } = this.props;
    dispatch(hideFormSigning());

    if (id) {
      dispatch(revertForm(id));
    }

    if (formGroupId) {
      dispatch(revertFormGroup(formGroupId));
    }

    if (onCancel) {
      onCancel();
    }
  }

  onSignForm() {
    const {
      formType,
      id,
      dispatch,
      onSubmit,
      formData,
      formGroupId,
      formGroup,
      questionnaire,
      selectedAccountId,
      customerId,
      showAffidavit
    } = this.props;
    const { capacity, signDate } = this.state;
    let { printName, signName } = this.state;

    if (!printName) {
      printName = '';
    }

    if (!signName) {
      signName = '';
    }

    let collectableSupportingDocData = null;

    if (showAffidavit) {
      collectableSupportingDocData = {
        accountId: selectedAccountId,
        customerName: formGroup ? `${ questionnaire?.name?.firstName } ${ questionnaire?.name?.lastName }` : questionnaire?.name?.name,
        printName,
        customerId,
        collectableSupportingDocType: 'AffidavitOfUnchangedStatus',
        signature: signName || printName
      };
    }

    if (formType) {
      dispatch(signForm(formType, id, signName || printName, capacity, signDate, collectableSupportingDocData));
    }

    if (formGroup) {
      dispatch(signFormGroup(formGroup.key, formGroupId, signName || printName, capacity, signDate, collectableSupportingDocData));
    }

    if (onSubmit) {
      onSubmit(signName, capacity, formData);
    }
  }

  setCapacityField() {
    const { formType, formGroup, usePreQualifyingQuestionnaire, questionnaire, intl } = this.props;
    let capacity = '';
    if (usePreQualifyingQuestionnaire) {
      capacity = questionnaire?.signer?.capacity;
      switch (formType) {
        case 'w8ben':
        case 'w8ben_2021':
        case 'w9_2018':
        case 'w9_2024':
        case 'crsi':
        case 'crsi_2024':
        case 'crscp': {
          const capacities = intl.messages['questionnaire.signer.capacities.individual'];
          if (!capacities) {
            break;
          }
          const matchedCapacity = capacities.find(x => x.value === capacity);
          if (matchedCapacity?.label) {
            capacity = matchedCapacity.label;
          }
          break;
        }
        case 'crse': {
          const capacities = intl.messages['questionnaire.signer.capacities.entity'];
          if (!capacities) {
            break;
          }
          const matchedCapacity = capacities.find(x => x.value === capacity);
          if (matchedCapacity?.label) {
            capacity = matchedCapacity.label;
          }
          break;
        }
        default:
          break;
      }
      switch (formGroup?.key) {
        case 'crsiw8ben': {
          const capacities = intl.messages['questionnaire.signer.capacities.individual'];
          if (!capacities) {
            break;
          }
          const matchedCapacity = capacities.find(x => x.value === capacity);
          if (matchedCapacity?.label) {
            capacity = matchedCapacity.label;
          }
          break;
        }
        default:
          break;
      }
      this.setState({ capacity });
    } else {
      let elementName = document.getElementsByName('capacityField');
      if (elementName && elementName.length >= 1) {
        capacity = document.getElementById(elementName[0].id);
        if (capacity != null) {
          if (capacity.options[capacity.selectedIndex].text === 'Other') {
            elementName = document.getElementsByName('capacityFieldOther');
            capacity = document.getElementById(elementName[0].id);
            this.setState({ capacity: capacity.value });
            return;
          }
          this.setState({ capacity: capacity.options[capacity.selectedIndex].text });
        }
      } else {
        const form = document.getElementById('blankForm');
        if (form && form.elements) {
          switch (formType) {
            case 'w8ben':
            case 'w8ben_2021':
              capacity = form.elements.namedItem('part3.actingCapacity').value;
              break;
            case 'crsi':
            case 'crsi_2024':
              capacity = form.elements.namedItem('part3.capacity').value;
              break;
            case 'crse':
            case 'crscp':
              capacity = form.elements.namedItem('part4.capacity').value;
              break;
            default:
              break;
          }
        }
        this.setState({ capacity });
      }
    }
  }

  setStateParameters() {
    const { formType, formGroup, usePreQualifyingQuestionnaire, questionnaire } = this.props;
    let formPrintName = null;
    let formDate = null;

    if (usePreQualifyingQuestionnaire) {
      formPrintName = questionnaire?.signer?.name ?? null;

      switch (formType) {
        case 'w9_2018':
        case 'w9_2024':
          formDate = format(new Date(), 'MM-dd-yyyy');
          break;
        case 'w8ben':
        case 'w8ben_2021':
          formDate = format(new Date(), 'MM-dd-yyyy');
          break;
        case 'w8bene_2021':
        case 'w8imy_2021':
          formDate = format(new Date(), 'MM-dd-yyyy');
          break;
        case 'crsi':
        case 'crsi_2024':
        case 'crscp':
        case 'crse':
        case 'fatca_crse_2023':
        case 'fatca_crsi_2023':
          formDate = format(new Date(), 'dd-MM-yyyy');
          break;
        case 'rc518':
        case 'rc518_2024':
        case 'rc518_2025':
        case 'rc519':
        case 'rc519_2024':
        case 'rc519_2025':
          formDate = format(new Date(), 'yyyy-MM-dd');
          break;
        default:
          break;
      }

      if (formGroup) {
        switch (formGroup.key) {
          case 'crsiw8ben':
            formDate = format(new Date(), 'MMMM dd, yyyy');
            break;
          default:
            break;
        }
      }
    }

    const form = document.getElementById('blankForm');
    if (form && form.elements) {
      switch (formType) {
        case 'w8bene_2017':
        case 'w8bene_2021':
          formPrintName = form.elements.namedItem('part30.printName').value;
          formDate = form.elements.namedItem('part30.date').value;
          break;
        case 'w8ben':
        case 'w8ben_2021':
          formPrintName = form.elements.namedItem('part3.printName').value;
          formDate = form.elements.namedItem('part3.date').value;
          break;
        case 'w9_2018':
        case 'w9_2024':
          formPrintName = form.elements.namedItem('name').value;
          formDate = form.elements.namedItem('certification.date').value;
          break;
        case 'w8eci':
        case 'w8eci_2021':
          formPrintName = form.elements.namedItem('part2.printName').value;
          formDate = form.elements.namedItem('part2.date').value;
          break;
        case 'w8exp':
        case 'w8exp_2023':
          formPrintName = form.elements.namedItem('part4.printName').value;
          formDate = form.elements.namedItem('part4.date').value;
          break;
        case 'w8imy_2017':
        case 'w8imy_2021':
          formPrintName = form.elements.namedItem('part29.printName').value;
          formDate = form.elements.namedItem('part29.date').value;
          break;
        case 'crsi':
        case 'crsi_2024':
          formPrintName = form.elements.namedItem('part3.printName').value;
          formDate = form.elements.namedItem('part3.dateSigned').value;
          break;
        case 'crse':
          formPrintName = form.elements.namedItem('part4.printName').value;
          formDate = form.elements.namedItem('part4.dateSigned').value;
          break;
        case 'crscp':
          formPrintName = form.elements.namedItem('part4.printName').value;
          formDate = form.elements.namedItem('part4.dateSigned').value;
          break;
        default:
          formPrintName = null;
          formDate = null;
      }
    }

    this.setState({ printName: formPrintName, signDate: formDate });
    this.setCapacityField();
  }

  // eslint-disable-next-line class-methods-use-this
  getBtnConfirmTitle(formGroup, isSigningForm, intl) {
    this.baseId = 'formSigning.button.';

    if (!formGroup) {
      this.baseId += isSigningForm ? 'signingForm' : 'signForm';
    } else {
      this.baseId += isSigningForm ? 'signingForms' : 'signForms';
    }

    return intl.formatMessage({ id: this.baseId });
  }

  isW8Form() {
    const { formType } = this.props;
    return formType.indexOf('w8') !== -1;
  }

  isW9Form() {
    const { formType } = this.props;
    return formType === 'w9_2018' || formType === 'w9_2024';
  }

  isCrsForm() {
    const { formType } = this.props;
    return formType.startsWith('crs');
  }

  render() {
    const { isSigningForm, isNameInvalid, usePreQualifyingQuestionnaire, formGroup, intl } = this.props;
    const { printName, signDate, signName, capacity } = this.state;

    const title = <h1><LocalisedMessage id="formSigning.signature" /></h1>;
    const otherFormData = <div>
      { this.isW8Form() && <p>
        <span className="disclaimer-text"><LocalisedMessage id="formSigning.irsConsentWarning" /></span>
      </p> }
      { !formGroup
      && <React.Fragment>
        <p className="pb-2"><LocalisedMessage id="formSigning.printName" /><br />
          <span className="cp-primary">{ printName }</span>
        </p>
        <p><LocalisedMessage id="formSigning.dateGivenOnForm" /> { usePreQualifyingQuestionnaire
         && `(${ this.isCrsForm() ? intl.formatMessage({ id: 'formSigning.crsDateFormat' }) : intl.formatMessage({ id: 'formSigning.nonCrsDateFormat' }) })` }<br />
          <span className="cp-primary">{ signDate }</span>
        </p>
        </React.Fragment> }
      { usePreQualifyingQuestionnaire && !formGroup
        && <p><LocalisedMessage id="formSigning.capacity" /><br />
          <span className="cp-primary" name="capacity">{ capacity }</span>
        </p> }
      {formGroup && usePreQualifyingQuestionnaire
      && <React.Fragment>
        <p><LocalisedMessage id="formSigning.dateGivenOnForms" /> <br />
          <span className="cp-primary">{ signDate }</span>
        </p>
        <p className="pb-2">W-8BEN <LocalisedMessage id="formSigning.printName" /><br />
          <span className="cp-primary">{ printName }</span>
        </p>
        <p className="pb-2">W-8BEN <LocalisedMessage id="formSigning.capacity" /><br />
          <span className="cp-primary" name="capacity">{ capacity }</span>
        </p>
        <p className="pb-2">CRS-I <LocalisedMessage id="formSigning.printName" /><br />
          <span className="cp-primary">{ printName }</span>
        </p>
        <p className="pb-2">CRS-I <LocalisedMessage id="formSigning.capacity" /><br />
          <span className="cp-primary" name="capacity">{ capacity }</span>
        </p>
        </React.Fragment> }
    </div>;
    const w9FormInput = <div>
      <p>
        <strong className="disclaimer-text"><LocalisedMessage id="formSigning.irsConsentWarning" /></strong>
      </p>
      <p className="pb-2"><LocalisedMessage id="formSigning.printName" /><br />
        {usePreQualifyingQuestionnaire ? <span name="signName">{ printName }</span> : <input type="text" name="signName" value={ signName } onChange={ event => this.onChangePrintName(event) } /> }
      </p>
      <p><LocalisedMessage id="formSigning.dateGivenOnForm" /> { usePreQualifyingQuestionnaire && intl.formatMessage({ id: 'formSigning.nonCrsDateFormat' }) }<br />
        <span className="cp-primary">{ signDate }</span>
      </p>
      <p className="mb-0">{ usePreQualifyingQuestionnaire ? <LocalisedMessage id="formSigning.capacity" /> : 'Capacity In Which Acting (if not person named on Line 1)'}<br />
        { usePreQualifyingQuestionnaire ? <span name="capacity">{ capacity }</span> : <input type="text" name="capacity" onChange={ event => this.onChangeCapacity(event) } value={ capacity } /> }
      </p>
    </div>;

    const content = <div>
      { !formGroup ? <LocalisedMessage id="formSigning.singleDeclaration" /> : <div><LocalisedMessage id="formSigning.multiFormDeclaration" /><LocalisedMessage id="formSigning.irsConsentWarning" /></div> }
      { this.isW9Form() ? w9FormInput : otherFormData }
      { isNameInvalid && <div className="notifs inline">
        <div className="notif inline error">
          <span><LocalisedMessage id="formSigning.printNameMismatch" /> </span>
        </div>
      </div> }
    </div>;

    return (<ModalWrapper
      title={ title }
      closeButtonName={ intl.formatMessage({ id: 'formSigning.signature' }) }
      content={ content }
      className={ `${ this.isW9Form() ? 'w9' : '' }` }
      onCancel={ () => this.onCancel() }
      onConfirm={ () => this.onSignForm() }
      showCancel={ false }
      btnConfirmTitle={ this.getBtnConfirmTitle(formGroup, isSigningForm, intl) }
      btnConfirmClass={ isSigningForm ? 'btn-active-form-signing' : '' }
      disableConfirm={ isSigningForm }
      id="form-signing"
    />);
  }
}

function mapStateToProps(state) {
  const {
    form: {
      formData,
      isSigningForm,
      isNameInvalid,
      selectedAccountId,
      validationResult: {
        customerId
      }
    },
    questionnaires: {
      formQuestionnaire
    },
    app: { onlineConfig },
  } = state;

  return {
    formData,
    questionnaire: formQuestionnaire?.answers,
    isSigningForm,
    isNameInvalid,
    usePreQualifyingQuestionnaire: onlineConfig && onlineConfig.usePreQualifyingQuestionnaire,
    selectedAccountId,
    customerId,
    showAffidavit: formQuestionnaire?.blocks?.find(b => b.id === 'signer')?.answers?.generateAffidavit === 'true'
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(FormSigning)));
